import React from 'react';

import { SVGProps } from './type';

function Icon(props: SVGProps) {
  const { size = 24, color = '#000', ...rest } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      {...rest}
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M17.248 2.25a2.991 2.991 0 013.002 3.001v.002l-.75-.003h.75v4.875a.75.75 0 01-1.5 0V5.247a1.49 1.49 0 00-1.497-1.497H4.5a.75.75 0 010-1.5h12.748zm0 0h-.001l.003.75v-.75h-.002z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M9.75 9a.75.75 0 01.75-.75h6a.75.75 0 010 1.5h-6A.75.75 0 019.75 9zM9.75 12a.75.75 0 01.75-.75H12a.75.75 0 010 1.5h-1.5a.75.75 0 01-.75-.75z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M4.678 3.762A1.5 1.5 0 003.381 6.25a.75.75 0 11-1.118 1 3 3 0 115.237-2v12a1.5 1.5 0 102.619-1 .75.75 0 01.56-1.25H12a.75.75 0 010 1.5h-.095l.005.02a3 3 0 01-.313 2.23H12a.75.75 0 010 1.5H9a3.002 3.002 0 01-3-3v-12a1.5 1.5 0 00-1.322-1.488zM15.75 13.5V21h6v-5.314L19.564 13.5H15.75zm-1.17-1.17c.21-.212.497-.33.795-.33h4.5a.75.75 0 01.53.22l2.625 2.625c.141.14.22.331.22.53v6a1.125 1.125 0 01-1.125 1.125h-6.75a1.125 1.125 0 01-1.125-1.125v-8.25c0-.298.118-.585.33-.796z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M19.875 12a.75.75 0 01.75.75v1.875H22.5a.75.75 0 010 1.5h-2.625a.75.75 0 01-.75-.75V12.75a.75.75 0 01.75-.75z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default Icon;
